import React, { useEffect, useState } from "react";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import api from "../../../auth/api";
import { alertSuccess, alertError } from "../../../components/Alert";
import Add from "./AddDonation"
import EditableTable from "./DonationTable";
import { fetchCountryList } from "@/slices/LocationSlice/countrySlice";
import { useSelector, useDispatch } from "react-redux";


export default function Donation() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [changeLogData, setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['title', 'status', 'agency', 'detailFirstPage', 'detailEndPage', 'multipleOfPoints', 'Point', 'country'];
  const [addDis, setAddDis] = useState(false);
  const [agencyList, setAgencyList] = useState([]);
  const { countryList, status } = useSelector((state) => state.countryList);


  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchCountryList());
    }
  }, [dispatch, status]);

  useEffect(() => {
    fetchData();
    getAgencyList();
  }, []);

  const getAgencyList = async () => {
    try {
      const response = await api.get("/redeem/panel/agency");
      setAgencyList(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const getAgencySubCategoryList = async () => {
  //   try {
  //     const response = await api.get("/redeem/panel/SubCategory");
  //     setAgencySubCategoryList(response.data.result);
  //     console.log(response.data.result)

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } 
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/redeem/panel/donation");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };
  const parseToJSONString = (input) => {
    if (typeof input === "string") {
      try {
        // Try parsing in case it's a stringified array
        const parsed = JSON.parse(input);
        return JSON.stringify(parsed);
      } catch {
        // Otherwise, split by comma and stringify
        return JSON.stringify(input.split(','));
      }
    }
    return JSON.stringify(input);
  };

  const handleSave = async () => {
    try {
      const agencyId = agencyList.filter((f) => f.agencyName === editedData.agency)[0].id;
      const countryId = countryList?.result?.filter(f => f.title === editedData.country)[0]?.id;
      const detailFirstPage = parseToJSONString(editedData.detailFirstPage);
      const detailEndPage = parseToJSONString(editedData.detailEndPage);


      const finalData = {
        id: editedData.id,
        title: editedData.title,
        status: editedData.status,
        agency: agencyId,
        country: countryId,
        detailFirstPage: detailFirstPage,
        detailEndPage: detailEndPage,
        Point: editedData.Point,
        multipleOfPoints: editedData.multipleOfPoints
      };

      // console.log(finalData)

      // console.log(finalData);
      const resp = await api.patch(`/redeem/panel/donation`, finalData);
      let succMess = resp.data.success;
      alertSuccess(succMess);
      setEditRowId(null)
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors);
      console.error("Error updating data:", error);
    }
  };


  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };



  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status" || field === "multipleOfPoints") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };


  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = (row) => {
    console.log(row.id);
    alert(row.id)
  }


  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
        agencyList={agencyList}
        countryList={countryList?.result}
      />
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Donation
        </button>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />

      <Modal isOpen={addDis} onClose={() => setAddDis(false)} title="Add new donation" content={<Add agencyList={agencyList} countryList={countryList?.result} onSuccess={fetchData}  onClose={() => setAddDis(false)}  />} />

    </div>
  );
}
